import { connect } from "react-redux";
import CarnivalConduct from "./carnivalConduct";
import { bindActionCreators } from "redux";
import {
  getSiteCarnivalChecklist,
  getLocationApprovalPending,
  getPocBySiteId,
  postSendReportMail,
  getCheckLocation,
  postCarnivalData,
  getCarnivalCompletedDetails
} from "services/redux/installation/siteInspection/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {getSiteData, calculateDistance, getDistanceData} from "../../../services/redux/DistanceCalculator/action";
import {
  postReportDetails,
  generateReport,
} from "services/redux/installation/materialRequisition/action";

import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  siteData: state.siteInspectionReducer.siteCarnivalChecklist,
  checklistDetails: state.siteInspectionReducer.siteCarnivalChecklistFilled,
  locationApproval: state.siteInspectionReducer.locationApproval,
  pocListBySiteId: state.siteInspectionReducer.pocListBySiteId,
  locationCheck : state.siteInspectionReducer.locationCheck,
  userProfile : state.loginReducer.userProfile,
  engDistanceData: state.leadDataReducer.engDistanceData,
  siteDetails: state.leadDataReducer.siteData,
  distanceDetails: state.leadDataReducer.distanceDetails,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteCarnivalChecklist,
      documentUploadUrl,
      postReportDetails,
      generateReport,
      getLocationApprovalPending,
      getPocBySiteId,
      postSendReportMail,
      getCheckLocation,
      calculateDistance,
      getSiteData,
      getDistanceData,
      documentUploadUrlPublic,
      postCarnivalData,
      getCarnivalCompletedDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CarnivalConduct);
